import { gql } from "@apollo/client";

export const ADD_ADDITIONAL_TNC = gql`
  mutation addAdditionalTnc($bookingId: ID! $additionalTnc:String!) {
    addAdditionalTnc(bookingId: $bookingId, additionalTnc:$additionalTnc)
  }
`;